import React, { useEffect, useState } from "react";
import NavBar from "./NavBar";
import Footer from "./Footer";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import CardClientes from "../components/Cards/CardClientes";
import CardColaboradores from "../components/Cards/CardColaboradores";
import CardHistoricoUsuarios from "../components/Cards/CardHistoricoUsuarios";
import CardMensagens from "../components/Cards/CardMensagens";
import { motion } from "framer-motion";

export default function Admin() {
  const [colaboradores, setColaboradores] = useState([]);
  const navigate = useNavigate();

  async function mostrarColaboradores() {
    const token = JSON.parse(localStorage.getItem("token"));
    try {
      const dados = await axios.get(
        "https://api-eyazs-production-8f74.up.railway.app/usuariosids",
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );
      if (dados) {
        setColaboradores(dados.data);
      }
    } catch (erro) {
      console.log(erro);
    }
  }

  useEffect(() => {
    mostrarColaboradores();
  }, []);

  const propsCardPlanos = { descricao: "Clientes" };
  const propsCardPagamento = { descricao: "Pagamento de Cheque" };
  const propsCardMessage = { descricao: "BroadCast" };
  const propsCardHistorico = { descricao: "Histórico" };

  return (
    <motion.div
      className="flex flex-col justify-between min-h-screen"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.8 }}
    >
      {/* Navbar */}
      <div className="bg-blue-500 h-[200px] lg:h-[240px]">
        <NavBar />
      </div>

      {/* Conteúdo Principal */}
      <div className="w-full px-1 sm:px-8 mx-auto flex justify-center -mt-[70px] lg:-mt-[150px] lg:z-10">
        <motion.div
          className="flex flex-col items-center gap-6 lg:flex-row lg:justify-center"
          initial="hidden"
          animate="visible"
          variants={{
            hidden: { opacity: 0 },
            visible: {
              opacity: 1,
              transition: { staggerChildren: 0.15 },
            },
          }}
        >
          {/* Card Clientes */}
          <motion.div
            className="w-full sm:w-[80%] lg:w-1/3"
            variants={{
              hidden: { opacity: 0, y: 30 },
              visible: { opacity: 1, y: 0 },
            }}
            whileHover={{ scale: 1.05 }}
            transition={{ type: "spring", stiffness: 300 }}
          >
            <button
              onClick={() => navigate("clientes")}
              className="w-full"
            >
              <CardClientes {...propsCardPlanos} />
            </button>
          </motion.div>

          {/* Card Colaboradores */}
          <motion.div
            className="w-full sm:w-[80%] lg:w-1/3"
            variants={{
              hidden: { opacity: 0, y: 30 },
              visible: { opacity: 1, y: 0 },
            }}
            whileHover={{ scale: 1.05 }}
            transition={{ type: "spring", stiffness: 300 }}
          >
            <button
              onClick={() => navigate("colaboradores")}
              className="w-full"
            >
              <CardColaboradores {...propsCardPagamento} />
            </button>
          </motion.div>

          {/* Card Broadcast */}
          <motion.div
            className="w-full sm:w-[80%] lg:w-1/3"
            variants={{
              hidden: { opacity: 0, y: 30 },
              visible: { opacity: 1, y: 0 },
            }}
            whileHover={{ scale: 1.05 }}
            transition={{ type: "spring", stiffness: 300 }}
          >
            <button
              onClick={() => navigate("broadcast")}
              className="w-full"
            >
              <CardMensagens {...propsCardMessage} />
            </button>
          </motion.div>

          {/* Card Histórico */}
          <motion.div
            className="w-full sm:w-[80%] lg:w-1/3"
            variants={{
              hidden: { opacity: 0, y: 30 },
              visible: { opacity: 1, y: 0 },
            }}
            whileHover={{ scale: 1.05 }}
            transition={{ type: "spring", stiffness: 300 }}
          >
            <button
              onClick={() => alert("Em Manutenção")}
              className="w-full"
            >
              <CardHistoricoUsuarios {...propsCardHistorico} />
            </button>
          </motion.div>
        </motion.div>
      </div>

      {/* Footer */}
      <div className="bg-blue-500 mt-8">
        <Footer />
      </div>
    </motion.div>
  );
}
